import { render, staticRenderFns } from "./carouselMulti.vue?vue&type=template&id=35689de2&scoped=true&"
import script from "./carouselMulti.vue?vue&type=script&lang=js&"
export * from "./carouselMulti.vue?vue&type=script&lang=js&"
import style0 from "./carouselMulti.vue?vue&type=style&index=0&id=35689de2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35689de2",
  null
  
)

component.options.__file = "carouselMulti.vue"
export default component.exports